import { AppRouter } from './core/router/AppRouter';
import { NavModuleProvider } from './core/contexts/NavModuleContext';
import { LineOfBizProvider } from './core/contexts/LineOfBizContext';
import { ReportsFilterProvider } from './core/contexts/ReportsFilterContext';

/**
 * `NavModuleProvider` lives here (rather than `main.tsx`) so route-level
 * components inside `AppRouter` can read/write the current top-level
 * module via `useNavModule()` while still sharing the same Auth/Tenant
 * providers above. `LineOfBizProvider` lives here for the same reason —
 * the active LOB is shared between the sidebar switcher and LOB-scoped
 * pages. `ReportsFilterProvider` shares the Reports Monitoring filters
 * between the sidebar selectors and the report-instance views.
 */
export default function App() {
  return (
    <NavModuleProvider>
      <LineOfBizProvider>
        <ReportsFilterProvider>
          <AppRouter />
        </ReportsFilterProvider>
      </LineOfBizProvider>
    </NavModuleProvider>
  );
}
